import CoverageNonLiabilityLinkModal from '@root/quotes/src/components/modals/coverage-non-liability-link-modal';
import PropTypes from '@root/vendor/prop-types';
import React from '@root/vendor/react';
import { StyleSheet, Theme } from '@root/core/src/utils/styles';

const NjTortLearnMoreModal = ({
  primaryBrandColor,
  infoBrandColor,
}) => (
  <CoverageNonLiabilityLinkModal
    infoBrandColor={infoBrandColor}
    linkText={'Learn more'}
    modalName={'NJ Tort Learn More Modal'}
    primaryBrandColor={primaryBrandColor}
  >
    <h2 css={styles.header}>Tort Selection</h2>
    <p css={styles.paragraph}>{'Tort can be understood as the "Right to Sue". In New Jersey, you must choose in what manner you wish to sue an at fault driver for "pain and suffering." No matter which you pick, you maintain the right to sue for your medical expenses and lost wages.'}</p>
    <p css={styles.paragraph}><strong>{'Option 1: Limited Tort (Right to Sue)'}</strong></p>
    <p css={styles.paragraph}>{'By choosing this, you will only be able to sue for pain and suffering if your injury is permanent or very serious, such as:'}</p>
    <ul css={styles.list}>
      <li>{'Loss of a body part or a fetus.'}</li>
      <li>{'Significant scarring or disfigurement.'}</li>
      <li>{'A displaced bone fracture.'}</li>
      <li>{'An injury that will never fully heal (confirmed by a doctor).'}</li>
      <li>{'Death.'}</li>
    </ul>
    <p css={styles.paragraph}><strong>{'Best for: '}</strong>{'Drivers looking for the lowest possible monthly price.'}</p>
    <p css={styles.paragraph}><strong>{'Option 2: Full Tort (Right to Sue)'}</strong></p>
    <p css={styles.paragraph}>{'You can sue the person at fault for pain and suffering for any injury.'}</p>
    <p css={styles.paragraph}><strong>{'Best for: '}</strong>{'Total peace of mind, though it significantly increases your premium.'}</p>
  </CoverageNonLiabilityLinkModal>
);

NjTortLearnMoreModal.propTypes = {
  infoBrandColor: PropTypes.string,
  primaryBrandColor: PropTypes.string,
};

export default NjTortLearnMoreModal;

const styles = StyleSheet.create({
  header: {
    ...Theme.heading2(),
    marginBottom: 24,
  },
  paragraph: {
    ...Theme.paragraph1(),
    marginBottom: 12,
  },
  list: {
    ...Theme.paragraph1(),
    listStyleType: 'disc',
    marginBottom: 12,
    paddingLeft: 24,
  },
});
